import api from '@/shared/api'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const initializeCartInfo = createAsyncThunk(
    'cart/initializeCartInfo',
    async (_, thunkApi) => {
        try {
            const response = await api.get(
                'index.php?route=module/d_quickcheckout/stepsInit'
            )
            return response.data
        } catch (error) {
            thunkApi.rejectWithValue(error)
        }
    }
)

export const updateArea = createAsyncThunk(
    'cart/updateArea',
    async (body, thunkApi) => {
        try {
            console.log(body);
            const response = await api.post(
                'index.php?route=d_quickcheckout/area/update',
                body,
                { withCredentials: true }
            )
            return response.data
        } catch (error) {
            thunkApi.rejectWithValue(error)
        }
    }
)

export const updateShippingMethod = createAsyncThunk(
    'cart/updateShippingMethod',
    async (body, thunkApi) => {
        try {
            const response = await api.post(
                'index.php?route=d_quickcheckout/shipping_method/update',
                body,
                { withCredentials: true }
            )
            return response.data
        } catch (error) {
            thunkApi.rejectWithValue(error)
        }
    }
)

export const updatePaymentMethod = createAsyncThunk(
    'cart/updatePaymentMethod',
    async (body, thunkApi) => {
        try {
            const response = await api.post(
                'index.php?route=d_quickcheckout/payment_method/update',
                body,
                { withCredentials: true }
            )
            return response.data
        } catch (error) {
            thunkApi.rejectWithValue(error)
        }
    }
)

export const updateShippingAddress = createAsyncThunk(
    'cart/updateShippingAddress',
    async (body, thunkApi) => {
        try {
            const response = await api.post(
                'index.php?route=d_quickcheckout/shipping_address/update',
                body,
                { withCredentials: true }
            )
            return response.data
        } catch (error) {
            thunkApi.rejectWithValue(error)
        }
    }
)

export const fetchConfirm = createAsyncThunk(
    'cart/fetchConfirm',
    async (body, thunkApi) => {
        console.log('🔴🔴🔴 [fetchConfirm] НАЧАЛО', body)
        try {
            const response = await api.post(
                'index.php?route=d_quickcheckout/confirm/update',
                body,
                { withCredentials: true }
            )
            console.log('🔴🔴🔴 [fetchConfirm] ОТВЕТ', response)
            console.log('🔴🔴🔴 [fetchConfirm] response.data', response.data)
            return response.data
        } catch (error) {
            console.error('🔴🔴🔴 [fetchConfirm] ОШИБКА', error)
            console.error('🔴🔴🔴 [fetchConfirm] error.response', error?.response)
            console.error('🔴🔴🔴 [fetchConfirm] error.response?.data', error?.response?.data)
            return thunkApi.rejectWithValue(error)
        }
    }
)

export const getModulBankData = createAsyncThunk(
    'cart/getModulBankData',
    async (_, thunkApi) => {
        try {
            const response = await api.get(
                'index.php?route=payment/modulbank/send'
            )
            return response.data
        } catch (error) {
            thunkApi.rejectWithValue(error)
        }
    }
)

export const fetchSuccess = createAsyncThunk(
    'cart/fetchSuccess',
    async (body, thunkApi) => {
        try {
            const response = await api.post(
                'index.php?route=checkout/success/successJson',
                body
            )
            return response.data
        } catch (error) {
            thunkApi.rejectWithValue(error)
        }
    }
)

export const getOrderidFromSession = createAsyncThunk(
    'cart/getOrderidFromSession',
    async (_, thunkApi) => {
        try {
            const response = await api.get(
                'index.php?route=checkout/success/getOrderId'
            )
            return response.data
        } catch (error) {
            thunkApi.rejectWithValue(error)
        }
    }
)

/**
 * Получение списка пунктов выдачи Яндекс Доставки
 * Бэкенд-прокси: index.php?route=module/d_quickcheckout/yandex/pickup-points/list
 */
export const getYandexPickupPoints = createAsyncThunk(
    'cart/getYandexPickupPoints',
    async (params, thunkApi) => {
        try {
            const response = await api.post(
                'index.php?route=module/d_quickcheckout/yandex/pickup-points/list',
                params || {},
                { withCredentials: true }
            )
            return response.data
        } catch (error) {
            thunkApi.rejectWithValue(error.response?.data || error.message)
        }
    }
)

const initialState = {
    area: null,
    areaType: null,
    areaZoneId: null,
    shippingMethod: null,
    shippingMethodValue: null,
    shippingMethods: null,
    shippingAddress: null,
    paymentMethods: null,
    paymentMethodValue: null,
    paymentAddress: null,
    initializeIsLoading: true,
    initializeError: false,
    countItems: 0,
    countItemsLoading: 0,
    countItemsError: null,
    cartLoading: false,
    cartAjaxError: null,
    currentStep: 1,
    orderId: null,
    isOrderConfirm: false,
    modulBankData: null,
    successCode: null,
    customer: null,
    
    // Яндекс ПВЗ
    yandexPickupPoints: null,
    selectedPickupPoint: null,
    yandexPickupPointsLoading: false,
    yandexPickupPointsError: null,

    cdekEnabled: true,
    yandexEnabled: true,
}

export const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        changeCountItems: (state, action) => {
            state.countItems = action.payload
        },

        changeAreaType: (state, action) => {
            state.areaType = action.payload
        },

        changeAreaZodeId: (state, action) => {
            state.areaZoneId = action.payload
        },

        changeCurrentStep: (state, action) => {
            state.currentStep = action.payload
        },

        changeShippingMethodValue: (state, action) => {
            state.shippingMethodValue = action.payload
        },

        changePaymentMethodValue: (state, action) => {
            state.paymentMethodValue = action.payload
        },

        changeCartLoading: (state, action) => {
            state.cartLoading = action.payload
        },

        changeSelectedPickupPoint: (state, action) => {
            state.selectedPickupPoint = action.payload
        },

        resetPickupPoint: (state) => {
            state.selectedPickupPoint = null
        },

        reset: () => initialState,
    },

    extraReducers: (builder) => {
        builder

            .addCase(initializeCartInfo.pending, (state) => {
                state.initializeIsLoading = true
            })
            .addCase(initializeCartInfo.rejected, (state, action) => {
                state.initializeIsLoading = false
                state.initializeError = action.payload
            })
            .addCase(initializeCartInfo.fulfilled, (state, action) => {
                state.initializeError = null
                state.area = action.payload.area
                state.shippingMethod = action.payload.shipping_method
                state.shippingMethods = action.payload.shipping_methods
                state.paymentMethod = action.payload.payment_method
                state.initializeIsLoading = false
                state.paymentMethods = action.payload.payment_method.payment_methods
                // Исправлено: читаем из shipping_method (вложенный объект от stepsInit)
                state.cdekEnabled = action.payload.shipping_method?.cdek_enabled ?? true
                state.yandexEnabled = action.payload.shipping_method?.yandex_enabled ?? true
            })

            .addCase(updateArea.pending, (state) => {
                state.cartLoading = true
            })
            .addCase(updateArea.rejected, (state, action) => {
                state.cartLoading = false
                state.cartAjaxError = action.payload
            })
            .addCase(updateArea.fulfilled, (state, action) => {
                state.currentStep = action.payload.checkout_current_step
                state.cartLoading = false
                state.cartAjaxError = null
                state.shippingMethods = action.payload.shipping_methods
                state.cdekEnabled = action.payload.cdek_enabled ?? state.cdekEnabled
                state.yandexEnabled = action.payload.yandex_enabled ?? state.yandexEnabled
            })

            .addCase(updateShippingMethod.pending, (state) => {
                state.cartLoading = true
            })
            .addCase(updateShippingMethod.rejected, (state, action) => {
                state.cartLoading = false
                state.cartAjaxError = action.payload
            })
            .addCase(updateShippingMethod.fulfilled, (state, action) => {
                state.currentStep = action.payload.checkout_current_step
                state.cartLoading = false
                state.cartAjaxError = null
                state.shippingMethods = action.payload.shipping_methods
                state.paymentMethods = action.payload.payment_methods
                state.cdekEnabled = action.payload.cdek_enabled ?? state.cdekEnabled
                state.yandexEnabled = action.payload.yandex_enabled ?? state.yandexEnabled
            })

            .addCase(updatePaymentMethod.pending, (state) => {
                state.cartLoading = true
            })
            .addCase(updatePaymentMethod.rejected, (state, action) => {
                state.cartLoading = false
                state.cartAjaxError = action.payload
            })
            .addCase(updatePaymentMethod.fulfilled, (state, action) => {
                state.customer = action.payload.customer
                state.currentStep = action.payload.checkout_current_step
                state.cartLoading = false
                state.cartAjaxError = null
                state.shippingMethods = action.payload.shipping_methods
                state.paymentMethods = action.payload.payment_methods
            })

            .addCase(updateShippingAddress.pending, (state) => {
                state.cartLoading = true
            })
            .addCase(updateShippingAddress.rejected, (state, action) => {
                state.cartLoading = false
                state.cartAjaxError = action.payload
            })
            .addCase(updateShippingAddress.fulfilled, (state, action) => {
                state.currentStep = action.payload.checkout_current_step
                state.cartLoading = false
                state.cartAjaxError = null
                state.shippingMethods = action.payload.shipping_methods
                // Обновляем paymentMethods только если они есть в ответе
                if (action.payload.payment_methods) {
                    state.paymentMethods = action.payload.payment_methods
                }
            })

            .addCase(fetchConfirm.pending, (state) => {
                state.cartLoading = true
            })
            .addCase(fetchConfirm.rejected, (state, action) => {
                state.cartLoading = false
                state.cartAjaxError = action.payload
            })
            .addCase(fetchConfirm.fulfilled, (state, action) => {
                state.cartLoading = false
                state.cartAjaxError = null
                state.orderId = action.payload.order_id
                // 🔥 Сохраняем payment_methods если они есть в ответе
                if (action.payload.payment_methods) {
                    state.paymentMethods = action.payload.payment_methods;
                }
                if (state.paymentMethodValue !== 'modulbank') {
                    state.isOrderConfirm = true
                }
            })

            .addCase(getModulBankData.pending, (state) => {
                state.cartLoading = true
            })
            .addCase(getModulBankData.rejected, (state, action) => {
                state.cartLoading = false
                state.cartAjaxError = action.payload
            })
            .addCase(getModulBankData.fulfilled, (state, action) => {
                state.cartLoading = false
                state.cartAjaxError = null
                state.modulBankData = action.payload
            })

            .addCase(fetchSuccess.pending, (state) => {})
            .addCase(fetchSuccess.rejected, (state, action) => {})
            .addCase(fetchSuccess.fulfilled, (state, action) => {
                if (action.payload.status === 200) {
                    state.area = null
                    state.areaType = null
                    state.shippingMethod = null
                    state.shippingMethodValue = null
                    state.shippingMethods = null
                    state.shippingAddress = null
                    state.paymentMethods = null
                    state.paymentMethodValue = null
                    state.paymentAddress = null
                    state.initializeIsLoading = true
                    state.initializeError = false
                    state.countItems = 0
                    state.countItemsLoading = 0
                    state.countItemsError = null
                    state.cartLoading = false
                    state.cartAjaxError = null
                    state.currentStep = 1
                    state.orderId = action.payload.data.order_id
                    state.isOrderConfirm = false
                }
            })

            .addCase(getOrderidFromSession.fulfilled, (state, action) => {
                if (action.payload.status === 200) {
                    state.orderId = action.payload.order_id
                } else {
                    // console.error(action.payload.error)
                }
            })

            // Обработчики для ПВЗ
            .addCase(getYandexPickupPoints.pending, (state) => {
                state.yandexPickupPointsLoading = true
                state.yandexPickupPointsError = null
            })
            .addCase(getYandexPickupPoints.rejected, (state, action) => {
                state.yandexPickupPointsLoading = false
                state.yandexPickupPointsError = action.payload
            })
            .addCase(getYandexPickupPoints.fulfilled, (state, action) => {
                state.yandexPickupPointsLoading = false
                state.yandexPickupPointsError = null
                state.yandexPickupPoints = action.payload.points || []
            })
    },
})

export const {
    changeCountItems,
    changeAreaType,
    changeCurrentStep,
    changeShippingMethodValue,
    changePaymentMethodValue,
    changeAreaZodeId,
    changeCartLoading,
    changeSelectedPickupPoint,
    resetPickupPoint,
    reset,
} = cartSlice.actions
export default cartSlice.reducer